import React, { useState, useEffect, useContext } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarcode, faTruckLoading } from '@fortawesome/free-solid-svg-icons';
import { Typography, Grid, Card, CardContent, Avatar, Chip, TextField, MenuItem, Button, Tooltip, Box, Autocomplete } from '@mui/material';
import moment from "moment";
import { Flex } from '@chakra-ui/react';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import 'moment/locale/es-mx';
import { esES as localeDate } from '@mui/x-date-pickers/locales'
import PrintIcon from '@mui/icons-material/Print';
import { FindInPage } from '@mui/icons-material';
import ModalEmbarques from '../../components/usuarios/ModalEmbarques';
import Pagination from "@mui/material/Pagination";
import ModalActualizarEstatus from '../../components/usuarios/ModalActualizarEstatus';
import EditIcon from '@mui/icons-material/Edit';
import { account } from '../../shared/Utils';
import { useNavigate } from "react-router-dom";
import { Menu } from '../../app/util/permisos';
import { Acciones } from "../../app/util/permisos"
import { ModalComponent } from "../../app/common/ModalComponent";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../app/store/root";
import { EnumCatalogosEncabezado, EnumStatusEmbarque, EnumStatusEmbarqueString } from "../../shared/Enumerables";
import { format } from 'date-fns'
import usePagination from "../../shared/Pagintation";
import ModalDetalleEmbarque from '../../shared/modals/ModalDetalleEmbarque';
import { toJS } from "mobx";
import CachedIcon from '@mui/icons-material/Cached';
import { getColorEstatusEmbarque } from "../../app/util/util";
import { blobToBase64 } from "../../app/util/util";
import IconEmbarquesStatus from "../../shared/components/IconEmbarquesStatus";


const EmbarquesPage = () => {
    const navigate = useNavigate();
    const [permisosUsuario, setPermisosUsuario] = React.useState([])

    const rootStore = useContext(RootStoreContext);

    const {
        getValoresCatalogo,
    } = rootStore.catalogosStore

    const {
        embarquesFilter,
        getEmbarques,
        onFilter,
        setEntityEmbarque,
        getExcel,
        bloquearEmbarque,
        desbloquearEmbarque,
        consultarComprobanteArchivo: _consultarComprobanteArchivo,
        getEmbarqueFile: _getEmbarqueFile,
    } = rootStore.embarqueStore

    // let {
    //     embarqueActual,
    // } = rootStore.embarqueStore

    let [page, setPage] = useState(1);
    const PER_PAGE = 5;
    const count = Math.ceil(embarquesFilter.length / PER_PAGE);
    const _DATA = usePagination(embarquesFilter, PER_PAGE);
    const handleChange = (e, p) => {
        var xx = _DATA
        setPage(p);
        _DATA.jump(p);
    };

    useEffect(() => {
        document.title = 'Lilofy | Embarques';
        if (!account.getPermisosUsuario().some(a => a.clavePermiso == Menu.Embarques && a.tienePermiso)) {
            console.log('No tengo permisos para la pantalla Embarques');
            navigate("/Usuarios/AccessDenied");
        } else {
            setPermisosUsuario(account.getPermisosUsuario())
            iniciarValores()
        }
    }, [])

    const iniciarValores = async () => {
        rootStore.logisticBackdropStore.openLoading()
        let estatus = await getValoresCatalogo(EnumCatalogosEncabezado.EstatusEmbarque)
        if (estatus != null) {
            estatus = [{ id: -1, valor: "Todos" }].concat(estatus)
            setCatalogoEstatus(estatus)
        }
        let embarques = await getEmbarques(modelFilter)
        onFilter('')
        setModelFilter({ FechaInicio: new Date(), FechaFin: new Date(), IdEstatus: null })
        rootStore.logisticBackdropStore.closeLoading()
    }

    const [modelFilter, setModelFilter] = useState({ FechaInicio: null, FechaFin: null, IdEstatus: null })
    const [catalogoEstatus, setCatalogoEstatus] = useState([])

    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClose = () => {
        setAnchorEl(null);
    };

    // const estadoEmbarque = createContext(embarque);

    //MODAL EDITAR EMBARQUE
    const [embarqueEditar, setEmbarqueEditar] = React.useState(null)
    const clickEditarEmbarque = async (embarque) => {
        rootStore.logisticBackdropStore.openLoading()
        // let embarqueActual = embarque.idEmbarque;
        const resp = await bloquearEmbarque(embarque.idEmbarque, true)
        rootStore.logisticBackdropStore.closeLoading()
        if (!resp.success) {
            
            rootStore.alertStore.alertError(resp.responseMessage)
            return
        }
        if (resp.success || resp.data) {
            setEmbarqueEditar(embarque)
            setOpenDialogEmbarque(true)
            handleClose()
            return
        }
    }

    //DIALOG NUEVO EMBARQUE
    const [openEmbarque, setOpenDialogEmbarque] = React.useState(null);
    const openDialogEmbarque = () => {
        setOpenDialogEmbarque(true);
        // page=setPage(1);
        handleClose();
    };

    const closeDialogEmbarque = async (resp, event, reason) => {
        if (reason && reason == "backdropClick")
            return;
        if (embarqueEditar != null) {
            rootStore.logisticBackdropStore.openLoading()
            await desbloquearEmbarque(embarqueEditar.idEmbarque)
            rootStore.logisticBackdropStore.closeLoading()
            setEmbarqueEditar(null)
        }
        setOpenDialogEmbarque(null);
    };

    const onFinishCloseDialogEmbarque = async (resp) => {
        setOpenDialogEmbarque(null);
        if (resp) {
            let embarques = await getEmbarques({ FechaInicio: null, FechaFin: null, IdEstatus: null })
            onFilter('')
            page=setPage(1);
            setEmbarqueEditar(null)

        }
    }
    //DIALOG ACTUALIZAR ESTATUS
    const [openActualizar, setOpenDialogActualizar] = React.useState(null);

    const openDialogActualizar = async (embarque) => {
        rootStore.logisticBackdropStore.openLoading()
        localStorage.setItem("LastEmbarque", embarque.idEmbarque);
        const resp = await bloquearEmbarque(embarque.idEmbarque, false)
        rootStore.logisticBackdropStore.closeLoading()
        if (!resp.success) {
            rootStore.alertStore.alertError(resp.responseMessage)
            return
        }
        if (resp.success || resp.data) {
            setEmbarqueEditar(embarque)
            setOpenDialogActualizar(true)
            handleClose()
            page=setPage(1);

            return
        }
    }

    const closeDialogActualizar = async (resp, event, reason) => {
        if (reason && reason == "backdropClick")
            return;
        if (embarqueEditar != null) {
            rootStore.logisticBackdropStore.openLoading()
            localStorage.removeItem("LastEmbarque");
            await desbloquearEmbarque(embarqueEditar.idEmbarque)
            rootStore.logisticBackdropStore.closeLoading()
            setEmbarqueEditar(null)
        }
        setOpenDialogActualizar(null)
    }

    const onFinishCloseDialogActualizar = async (resp) => {
        setOpenDialogActualizar(null);
        if (true) {
            setEmbarqueEditar(null)
            await getEmbarques({ FechaInicio: null, FechaFin: null, IdEstatus: null })
            onFilter('')
            setPage(1);
        }
    }

    //DIALOG DETALLE
    const [openDetalle, setOpenDialogDetalle] = React.useState(null);

    const openDialogDetalle = (embarque) => {
        setEntityEmbarque(embarque)
        setOpenDialogDetalle(true);
        handleClose();
    }

    const closeDialogDetalle = (event, reason) => {
        if (reason && reason == "backdropClick")
            return;
        setOpenDialogDetalle(null);
    }

    const setValueFiltro = (key, value) => {
        setModelFilter({ ...modelFilter, ...{ [key]: value } });
    }

    const getEmbarquesFilter = async () => {
        rootStore.logisticBackdropStore.openLoading()        
        const embarques = await getEmbarques(modelFilter)
        onFilter('')
        page = setPage(1);
        rootStore.logisticBackdropStore.closeLoading()
    }

    const getFormatDate = (today) => {
        if (Date.parse(today)) {
            let fecha = new Date(today)
            return format(fecha, "dd/MM/yyyy hh:mm aaa")
        } else {
            return 'Sin Definir'
        }
    }

    const consultarComprobanteArchivo = async (embarque) => {
        rootStore.logisticBackdropStore.openLoading()
        await _consultarComprobanteArchivo(embarque.idEmbarque)
        rootStore.logisticBackdropStore.closeLoading()
    }

    const getEmbarqueFile = async (embarque) => {
        let pdf = await _getEmbarqueFile(embarque.idEmbarque)
        const url = window.URL.createObjectURL(new Blob([pdf.data], { type: "application/pdf" }));
        window.open(url, '_blank');
    }

    return (
        <>
            <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="es-mx" localeText={localeDate.components.MuiLocalizationProvider.defaultProps.localeText}>
                <div className='main-container'>
                    <div className='mb-2 d-flex' style={{ alignItems: 'center' }}>
                        <Box sx={{ marginRight: '16px', fontSize: 25 }} color="primary.main">
                            <FontAwesomeIcon icon={faTruckLoading} />
                        </Box>
                        <Typography color='primary' variant='h4'>
                            Embarques
                        </Typography>
                    </div>
                    <Card className='card'>
                        <CardContent>
                            {permisosUsuario.some(a => a.clavePermiso === Acciones.Alta_embarque && a.tienePermiso) && (
                                <Grid container direction={'row'} justifyContent="end" alignItems={"center"}>
                                    <Grid item>
                                        <Button onClick={openDialogEmbarque}
                                            variant="contained">
                                            Nuevo embarque
                                        </Button>
                                    </Grid>
                                </Grid>
                            )}
                            <Grid container columnSpacing={2} direction={'row'} alignItems={"center"} mb={1}>
                                <Grid item lg={2} md={2} sm={4} xs={6}>
                                    <DatePicker
                                        label="Fecha inicio"
                                        value={modelFilter.FechaInicio}
                                        onChange={(newValue) => {
                                            if (newValue) {
                                                if (newValue.format() == 'Invalid date') setValueFiltro("FechaInicio", null)
                                                else setValueFiltro("FechaInicio", newValue.format())
                                            }
                                            else setValueFiltro("FechaInicio", null)
                                        }}
                                        renderInput={({ inputRef, inputProps, InputProps }) => (
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <TextField
                                                    label="Fecha inicio"
                                                    size="small"
                                                    margin="normal"
                                                    fullWidth
                                                    ref={inputRef} {...inputProps}
                                                />
                                                {InputProps?.endAdornment}
                                            </Box>
                                        )}
                                    />
                                </Grid>
                                <Grid item lg={2} md={2} sm={4} xs={6}>
                                    <DatePicker
                                        label="Fecha fin"
                                        value={modelFilter.FechaFin}
                                        onChange={(newValue) => { setValueFiltro("FechaFin", newValue) }}
                                        renderInput={({ inputRef, inputProps, InputProps }) => (
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <TextField
                                                    label="Fecha fin"
                                                    size="small"
                                                    margin="normal"
                                                    fullWidth
                                                    ref={inputRef} {...inputProps}
                                                />
                                                {InputProps?.endAdornment}
                                            </Box>
                                        )}
                                    />
                                </Grid>
                                <Grid item lg={2} md={3} sm={4} xs={6}>
                                    {/*<TextField
                                        size="small"
                                        margin="normal"
                                        select
                                        fullWidth
                                        id="selectEstatus"
                                        value={modelFilter.IdEstatus}
                                        label="Estatus"
                                        onChange={(e) => { setValueFiltro('IdEstatus', e.target.value) }}>
                                        <MenuItem value={null}><em>seleccionar</em></MenuItem>
                                        {catalogoEstatus.map((estatus) => (
                                            <MenuItem id={estatus.id} value={estatus.id}>{estatus.valor}</MenuItem>
                                        ))}
                                    </TextField>*/}
                                    <Autocomplete
                                        size="small"
                                        margin="normal"
                                        fullWidth
                                        id="selectEstatus"
                                        label="Estatus"
                                        name="selectEstatus"
                                        onChange={(event, newValue) => {
                                            setValueFiltro('IdEstatus', newValue?.id ?? null)
                                        }}
                                        options={catalogoEstatus.map(a => { return { label: a.valor, id: a.id } })}
                                        renderInput={(params) => <TextField {...params} label="Estatus" />}
                                    >
                                    </Autocomplete>
                                </Grid>
                                <Grid item >
                                    <Button
                                        disabled={!(modelFilter.FechaInicio || modelFilter.FechaFin || modelFilter.IdEstatus)}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            getEmbarquesFilter()
                                        }}
                                        variant="contained">
                                        Buscar
                                    </Button>
                                </Grid>
                                <Grid item>
                                    {permisosUsuario.some(a => a.clavePermiso === Acciones.Exportar_información_embarque && a.tienePermiso) &&
                                        <Button
                                            variant="export"
                                            onClick={async () => {
                                                await getExcel(
                                                    modelFilter,
                                                    `Reporte de embarques (${moment(new Date()).format(
                                                        "DD/MM/YYYY"
                                                    )}).xlsx`
                                                );
                                            }}
                                        >
                                            Exportar a excel
                                        </Button>
                                    }
                                </Grid>
                            </Grid>
                            <Grid container direction={'row'} justifyContent="end" alignItems={"center"}>
                                <Grid item>
                                    <TextField
                                        size="small"
                                        margin="normal"
                                        fullWidth
                                        id="filter"
                                        label="Buscar"
                                        name="filter"
                                        onChange={(e) => onFilter(e.target.value)}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} >                                
                                {
                                embarquesFilter?.length > 0 ? (
                                    _DATA.currentData().map((embarque, index) => (
                                        <Grid item xs={12}>
                                            <Card className="card ">
                                                <CardContent >
                                                    <Grid container direction={'row'} spacing={2} columns={16} justifyContent="space-between">
                                                        <Grid lg={2} md={2} sm={3} xs={4} item direction={'column'} alignItems="center" display={'flex'}>
                                                            {/* <Avatar sx={{ width: 50, height: 50, bgcolor: 'secondary.main', marginBottom: '5px' }} variant="rounded">
                                                                <FontAwesomeIcon icon={faBarcode} />
                                                            </Avatar>
                                                            <Chip label={embarque.estatus} color={getColorEstatusEmbarque(embarque.estatus)} /> */}
                                                            <IconEmbarquesStatus idStatus={embarque.idEstatus} />
                                                            <Typography variant='subtitle' className="text-center">
                                                                {getFormatDate(embarque.fechaUltimoEstatus)}
                                                                {/*format(new Date(embarque.fechaUltimoEstatus.toUTCString()), 'dd/mm/yyyy')*/}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid lg={2} md={3} sm={3} xs={5} item direction={'column'} alignItems="center" display={'flex'} justifyContent={'center'}>
                                                            <Typography variant='h6' className="text-center">
                                                                No. de carta porte
                                                            </Typography>
                                                            <Typography variant='subtitle' mt={1}>
                                                                #{embarque.numeroCartaPorte}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs="auto" p={0}>
                                                            <Flex
                                                                h="100%"
                                                                w="2px"
                                                                bg="linear-gradient(90deg, rgba(224, 225, 226, 0) 0%, #E0E1E2 50%, rgba(224,225,226,0) 100%)">
                                                            </Flex>
                                                        </Grid>

                                                        <Grid lg={3} md={4} sm={4} xs={6} item direction={'column'} display={'flex'} justifyContent={'center'}>
                                                            <Typography variant='h6'>
                                                                Detalles del embarque
                                                            </Typography>
                                                            <Typography variant='subtitle'>
                                                                {embarque.comentario}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid lg={4} md={3} sm={4} xs={8} item direction={'column'} display={'flex'} justifyContent={'center'}>
                                                            <Typography variant='h6'>
                                                                Fecha estimada de llegada
                                                            </Typography>
                                                            <Typography variant='subtitle'>
                                                                {getFormatDate(embarque.fechaEstimadaLlegada)}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid sm={1} xs={6} item container direction={{ sm: 'column', xs: 'row' }} display={'flex'}
                                                            justifyContent={'center'} >
                                                            {permisosUsuario.some(a => a.clavePermiso == Acciones.Imprimir_embarque && a.tienePermiso) &&
                                                                <Tooltip title="Imprimir embarque" placement='top'>
                                                                    <PrintIcon fontSize='large' sx={{ marginBottom: '10px', cursor: 'pointer' }} onClick={() => getEmbarqueFile(embarque)} />
                                                                </Tooltip>
                                                            }
                                                            {permisosUsuario.some(a => a.clavePermiso == Acciones.Ver_detalle_embarque && a.tienePermiso) &&
                                                                <Tooltip title="Ver detalle" placement='top'>
                                                                    <FindInPage fontSize='large' sx={{ marginBottom: '10px', cursor: 'pointer' }} onClick={() => { openDialogDetalle(embarque) }} />
                                                                </Tooltip>
                                                            }
                                                            {permisosUsuario.some(a => a.clavePermiso == Acciones.Editar_embarque && a.tienePermiso) && embarque.estatus?.toUpperCase() !== EnumStatusEmbarqueString.Entregado &&
                                                                <Tooltip title="Editar" placement='top'>
                                                                    <EditIcon fontSize='large' sx={{ marginBottom: '10px', cursor: 'pointer' }} onClick={() => { clickEditarEmbarque(embarque) }} />
                                                                </Tooltip>
                                                            }
                                                            {permisosUsuario.some(a => a.clavePermiso == Acciones.Actualizar_estatus_embarque && a.tienePermiso) &&
                                                                <Tooltip title="Actualizar estatus" placement='top'>
                                                                    <CachedIcon fontSize='large' sx={{ marginBottom: '10px', cursor: 'pointer' }} onClick={() => { openDialogActualizar(embarque) }} />
                                                                </Tooltip>
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    ))
                                ) : (
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Typography variant="h6" style={{ margin: "auto" }} mt={2}>
                                            No se encontraron resultados
                                        </Typography>
                                    </div>
                                )}
                            </Grid>
                            <Pagination
                                count={count}
                                page={page}
                                onChange={handleChange}
                            />
                        </CardContent>
                    </Card>
                </div>

            </LocalizationProvider>
            <ModalComponent
                Open={openEmbarque}
                HandleClose={closeDialogEmbarque}
                ClassName="modal-xl"
                Body={() => (
                    <ModalEmbarques
                        onClose={() => closeDialogEmbarque(false)}
                        onFinish={(resp) => { onFinishCloseDialogEmbarque(resp);}}
                        modelEditar={embarqueEditar}
                    />
                )}
            />
            <ModalComponent
                Open={openDetalle}
                HandleClose={closeDialogDetalle}
                ClassName="modal-xl"
                Body={() => (
                    <ModalDetalleEmbarque
                        onClose={closeDialogDetalle}
                    />
                )}
            />
            <ModalComponent
                Open={openActualizar}
                HandleClose={closeDialogActualizar}
                ClassName="modal-xl"
                Body={() => (
                    <ModalActualizarEstatus
                        onClose={() => { closeDialogActualizar() }}
                        onFinish={(resp) => { onFinishCloseDialogActualizar(resp); }}
                        modelEditar={embarqueEditar}
                    />
                )}
            />
        </>
    );
}

export default observer(EmbarquesPage);